import { UserBackendModel } from '../../backend/customer/model/UserBackend.model';

export interface AuthenticatedUserStateInterface {
  user: UserBackendModel;
}

export const initAuthenticatedUserStateInterface: AuthenticatedUserStateInterface = {
  user: null,
};
